<template>
  <!-- _________________________ LOGIN _________________________ -->
  <div id="login-div">

    <h1 class="page-title mt-2">
      {{ $t('preloginTitle') }}
    </h1>
    <h2 class="content mt-3">
      {{ $t('preloginSubtitle') }}
    </h2>

    <form @submit.stop.prevent="handleIsEmailValid" class="mt-4" v-if="form.isEmailValid.value === null">

      <b-alert :show.sync="ui.showError" variant="danger">
        {{ ui.showErrorMessage }}
      </b-alert>

      <b-form-group
        :label="$t('loginFirstCredential')"
        label-for="username-input">
        <b-form-input
          id="username-input"
          v-model="form.username.value"
          type="email"
          placeholder="email.utilisateur@email.fr"
          required>
        </b-form-input>
      </b-form-group>
      <div class="mt-5">
        <b-button type="submit" class="btn-block" variant="primary">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('Next')}}</span> <i class="ph-custom ph-caret-circle-right-bold ml-1 align-self-center"/>
          </div>
        </b-button>
<!--        <div class="mt-3 d-flex justify-content-center">-->
<!--          <span class="content">-->
<!--            {{$t('Register.curious')}}-->
<!--          </span>-->
<!--           <a class="ml-1 signup-link">{{$t('Register.discover')}}</a>-->
<!--        </div>-->
      </div>
    </form>

  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'LoginComponent',

  data () {
    return {
      form: {
        username: {
          value: null
        },
        isEmailValid : {
          value: null
        }
      },
      ui: {
        showError: false,
        showErrorMessage: this.$i18n.t('internal.server.error'),
      },
    }
  },

  emits: ['showSignUpView', 'showLoginView', 'showRedirectProModal'],


  methods: {


    async handleIsEmailValid(){
      let formData = new FormData()
      formData.append('email',this.form.username.value.trim())

      await api({
        method: 'POST',
        url: '/apiMobile/isEmailValid',
        data: formData
      })
        .then(async (response) => {
          this.form.isEmailValid.value=response.data
          if(this.form.isEmailValid.value){
            this.$emit('showLoginView',this.form.username.value.trim())
          }else{
            this.$emit('showSignUpView',this.form.username.value.trim())
          }
          this.ui.showError = false
        })
        .catch(error => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 468) {
            //PRO
            this.$emit('showRedirectProModal',this.form.username.value.trim())
          }
          if (error.response && error.response.status === 467) {
            //OTHERS
            this.ui.showErrorMessage = this.$i18n.t('Login.error.email')
            this.ui.showError = true
          }
        })
    },

    goToHome () {
      this.$router.push({
        name: 'Home'
      })
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/components/RedirectLoginSignUp.vue